/** Fetch a fresh, internally consistent set of report signatures without mutating edits. */
export function signatureDataUrl(blob) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader()
		reader.onload = () => resolve(reader.result)
		reader.onerror = () => reject(new Error('서명 이미지를 읽지 못했습니다.'))
		reader.readAsDataURL(blob)
	})
}

export async function loadReportSignatures(users, fetchImage, toDataUrl = signatureDataUrl) {
	const images = new Map()
	const entries = await Promise.all(Object.entries(users || {}).map(async ([key, user]) => {
		const next = { ...user }
		const id = user?.id
		if (id === null || id === undefined || id === '') {
			next.sign = ''
		} else {
			const normalized = Number(id)
			if (!Number.isSafeInteger(normalized) || normalized < 0) {
				throw new Error('서명 사용자를 확인할 수 없습니다.')
			}
			if (!images.has(normalized)) {
				images.set(normalized, Promise.resolve(fetchImage(normalized)).then(res => toDataUrl(res.data)))
			}
			next.sign = await images.get(normalized)
		}
		return [key, next]
	}))
	return Object.fromEntries(entries)
}
